import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { Requestor } from 'types'
import { useSnackbarContext } from '../../context/SnackbarProvider/SnackbarProvider'

type ApprovalUpdateTypes = {
  PK: string
  SK: string
  _deal_uuid?: string
  requestor: Requestor
  approverId: string
}

const approveDeal = async ({ PK, SK, _deal_uuid, requestor, approverId }: ApprovalUpdateTypes) => {
  try {
    const slackToken = localStorage.getItem('slack_access_token')
    if (!slackToken) {
      throw new Error('No authentication token available')
    }

    const response = await axios.post(
      `${baseUrl}/aws/organizations_table/${PK}/${SK}/approve`, // Pass the dealId correctly here
      { requestor, approverId, slackToken }, // This is the payload with approverId
      {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: slackToken,
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Error approving the deal:', error)
    throw error // Propagate the error to handle it properly in the mutation
  }
}

export const useApproveDeal = () => {
  const queryClient = useQueryClient()
  const { showSnackbar } = useSnackbarContext()

  const mutation = useMutation({
    mutationFn: approveDeal,
    onSuccess: (data, variables) => {
      console.log('Deal approved successfully:', data)
      showSnackbar('Deal Approved successfully', 'success')

      // Merge response data into item-level cache
      // Note: SEARCH_DATA_KEY is updated by the call-site via syncDealFields
      // Note: org-level cache is updated by the call-site after computing final status
      if (data?.deal) {
        queryClient.setQueryData(['item', variables.PK, variables.SK], (old: any) => {
          if (!old) return old
          return { ...old, ...data.deal }
        })
      }
    },
    onError: error => {
      console.error('Error in deal approval process:', error)
      showSnackbar('Error during approval', 'error')
    },
  })
  return mutation
}
